export var PurchaseOrderTabKeys = {
    PurchaseOrderOtherTab: "purchaseOrderOtherTab",
    PurchaseOrderStatusProgressTab: "purchaseOrderStatusProgressTab",
    GetPurchaseOrder: 'getPurchaseOrder'
};
